import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { VideoModelEntry } from '../types';


const COST_FACTOR = 1.5;

export const nvidiaModels: VideoModelEntry[] = [
    {
        id: 'cosmos-3-super',
        chef: providers.nvidia,
        providers: [
            {
                ...providers.nvidia,
                model: wavespeed('nvidia/cosmos-3-super/image-to-video'),
                getCost: ({ duration }) => {
                    return duration * 0.05 * COST_FACTOR;
                },
                getPassCount: ({ duration }) => {
                    return duration * 0.05 * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            first: {
                aspectRatios: ['16:9', '9:16', '4:3', '3:4', '1:1'],
                durations: [1, 2, 3, 4, 5, 6, 7],
                qualities: [],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            first: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['first'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];